import { QueryResult } from '@apollo/client';
import { useMemo } from 'react';

export const useStableResultData = <TResultData>(result: QueryResult<TResultData, any>) => {
  const { data, loading, previousData } = result;

  // when loading, the table jumps around twice, once while result.data is empty, and once after the new data renders.
  // to prevent this, if loading, we return the previous result. this means the table only rerenders once, when the new data comes through

  const rowData = useMemo(() => {
    if (data) {
      return data;
    }
    const newData = loading ? previousData : data;
    return newData;
  }, [data, loading, previousData]);

  return rowData;
};
